import { z } from 'zod';

export const passwordSchema = z
    .string()
    .min(8, { message: 'Must be at least 8 characters' })
    .refine((value) => /[A-Z]/.test(value), {
        message: 'Must contain at least one uppercase character',
    })
    .refine((value) => /[a-z]/.test(value), {
        message: 'Must contain at least one lowercase character',
    })
    .refine((value) => /\d/.test(value), {
        message: 'Must contain at least one number',
    })
    .refine((value) => /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value), {
        message: 'Password must contain a special character',
    });

export const AccountSchema = z
    .object({
        customernumber: z
            .string()
            .min(10, { message: 'Please enter a 10 digit number.' })
            .max(10, { message: 'Please enter a 10 digit number.' })
            .regex(/^[0-9]+$/, 'Only numbers are allowed.'),
        phone: z
            .string()
            .min(2, { message: 'Please enter a 10 digit phone number, including area code.' })
            .min(14, { message: 'Please enter a 10 digit phone number, including area code.' }),
        email: z
            .string()
            .email({ message: 'Please enter your email address in the format john@example.com.' })
            .min(6, { message: 'Please enter a valid email address.' })
            .max(50, 'Email must be less than 50 characters.'),
        subscribe: z.union([z.literal(true), z.literal(false), z.literal('indeterminate')]),
        newPassword: passwordSchema,
        retypeNewPassword: passwordSchema,
        IsPhoneCustomer: z.literal(true),
        IsGuest: z.literal(false),
    })
    .refine((data) => data.newPassword === data.retypeNewPassword, {
        message: 'Passwords do not match',
        path: ['retypeNewPassword'],
    });
